// FILE: packages/components/src/sprint/SprintHeroSection.tsx (CORRECTED)

import React from 'react';
import { motion } from 'framer-motion';
import { ImpactGridVisual } from '../../visuals/ImpactGridVisual';
import { CountdownTimer } from './CountdownTimer';

// --- THE FIX: PART 1 ---
// Update the props interface to be more flexible.
interface SprintHeroSectionProps {
    /** The main, large headline for the hero section. */
    headline: string;
    /** The smaller, descriptive sub-headline. */
    subheadline: string;
    /** An optional ISO date string. If provided, a countdown timer will be displayed. */
    targetDate?: string;
    // We remove `ctaText` and `onAction` because the parent page
    // should be responsible for rendering its own specific CTAs.
}
  
export const SprintHeroSection: React.FC<SprintHeroSectionProps> = ({ 
    headline, 
    subheadline, 
    targetDate // <-- Receive the new prop
}) => {
    return (
      <section className="bg-slate-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-20">
          <ImpactGridVisual />
        </div>
        <div className="container mx-auto px-4 py-20 md:py-28 text-center relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-slate-100 to-slate-400 leading-tight drop-shadow-lg">
              {headline}
            </h1>
            <p className="mt-6 max-w-3xl mx-auto text-lg md:text-xl text-slate-300 leading-relaxed">
              {subheadline}
            </p>

            {/* --- THE FIX: PART 2 --- */}
            {/* Conditionally render the entire countdown block ONLY if a targetDate is provided. */}
            {targetDate && (
              <div className="mt-12">
                <CountdownTimer targetDate={targetDate} />
                <p className="mt-4 text-slate-400 text-sm">
                  Time remaining until the sprint concludes.
                </p>
              </div>
            )}
            
            {/* The CTA Button is removed from here. The parent page will render it. */}
          </motion.div>
        </div>
      </section>
    );
};